import React, { Component } from "react";
import { Redirect } from 'react-router';
import { Link, Route , withRouter} from 'react-router-dom';
import Header from './../Header';
import Menu from './../Menu';
import './../../assets/css/thank-you.css';
import { QUESTION } from "./../../services/Questions";
import {CONFIG, URLS, getLoggedInData, checkAuth,encryptPHI,decryptPHI} from './../../helpers/Common';
import IdleTimer from 'react-idle-timer'
import Loader from './../Loader';

class SurgeonThankyou extends Component {

    constructor(props)
    {
        super(props);
        this.state = {
            patientData:'',
            redirect: false,
            patientId: '',
            surgeon_id: '',
            isLoading : false,
        };
        this.savePatientNarratives  = this.savePatientNarratives.bind(this);
        this.idleTimer = null
        this.onIdle = this._onIdle.bind(this)
        this.getLoggedInData  = getLoggedInData.bind(this)// Import from common
        this.checkAuth        = checkAuth.bind(this)// Import from common
        // this.redirectToHome         = this.redirectToHome.bind(this);
        
    }

    componentWillMount()
    {   
        checkAuth();
        let userData = getLoggedInData();
        this.setState({
            userData: userData,
            surgeonId: userData.user_id
        });
        
        var decryptedData = decryptPHI(CONFIG.ENCRYPTION_KEY,localStorage.getItem('data'));
        const patientData = decryptedData; 
        // console.log('will mount data',patientData)
        if(!patientData)
        {   
            this.props.history.push('/surgeon/patients');
        }

        let id      = this.props.location.pathname.split('/');  
        id          = id[(id.length)-1];

        this.setState({
            patientData:JSON.parse(patientData),
            patientId:id,
        })

        
    }
    
    _onIdle(e) {
        // console.log('user is idle', e)
        // console.log('last active', this.idleTimer.getLastActiveTime())
        localStorage.removeItem('data');
        localStorage.removeItem('patientProfile');
        this.setState({redirect: true});
    }

    componentDidMount() {
        //Clear local storage on close
        window.addEventListener("beforeunload", (ev) => {
            ev.preventDefault();
            localStorage.removeItem('data');
            localStorage.removeItem('patientProfile');
            this.setState({redirect: true});
        });
    }


    savePatientNarratives = (isExport)=>
    {

        this.setState({
            isLoading : true,
        })
        
        let data        = this.state.patientData;
        
        var encryptednarrative_summary = encryptPHI(CONFIG.ENCRYPTION_KEY,data.narrative_summary);
        var all_complains = data.all_complaints;
        for (let index = 0; index < all_complains.length; index++) 
        {
            all_complains[index].profileSummary = encryptPHI(CONFIG.ENCRYPTION_KEY,all_complains[index].profileSummary);
        }
        data.all_complaints = all_complains;
        data.narrative_summary = encryptednarrative_summary;

        data.isExport   = isExport;
        data.surgeon_id = this.state.surgeon_id;
        // console.log('all patient related data',data)
        
        QUESTION.savePatientNarrativesById(data).then(res => {
            localStorage.removeItem('data');
            localStorage.removeItem('patientProfile');
            this.setState({redirect: true});
            
        }).catch(err => {
            // console.log(err);
            alert("There was an error "); 
            this.setState({redirect: true});
        });
       
    }
    render() {
    if (this.state.redirect) {
        
        let path    = '/surgeon/patients/';
        return <Redirect push to={path} />;
    }
    return (
        <React.Fragment>
            <IdleTimer
            ref={ref => { this.idleTimer = ref }}
            element={document}
            onIdle={this.onIdle}
            debounce={250}
            timeout={1000 * 60 * CONFIG.IdleTimeOut} />
            <Header title="Narrative Accepted" titleImage="ic-medical-result.png" />
            <Menu />
            <div className="thank-you-bg">
            <section className="thank-you">
                <div className="txt-content">
                    <div className="container">
                        <img src={require("./../../assets/img/icons/ic-check.png")} alt="" />
                        <h2>Thank you for sharing a detailed history of your symptoms. This information will be shared with the Physician for diagnosis. </h2>
                        <p>If you wish to email yourself a copy of this history, please select the option given below. </p>
                    </div>
                </div>
            </section>

                <div className="sec-btn thank--btn">
                    <div className="loading-spiner" style={{visibility: this.state.isLoading ? 'visible' : 'hidden' }}>
                        <div style={{display: 'flex', justifyContent: 'center',position: 'absolute',left: '50%',top: '50%',transform: 'translate(-50%, -50%)'}}>
                            <Loader/>
                        </div>
                    </div>
                    <Link to="#" onClick={() => this.savePatientNarratives(false)} className="btn-img" style={{visibility: !this.state.isLoading ? 'visible' : 'hidden'}}>
                        <img src={require("./../../assets/img/icons/ic-close.png")} alt="" />
                        <span>Close</span>
                    </Link>
                    <Link to="#" onClick={() => this.savePatientNarratives(true)} className="btn-img" style={{visibility: !this.state.isLoading ? 'visible' : 'hidden' }}>
                        <img src={require("./../../assets/img/icons/ic-export.png")} alt="" />
                        <span>Export<br />Narrative</span>
                    </Link>
                </div>
            </div>
        </React.Fragment>
    );
  }
}

export default SurgeonThankyou;

